import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { SparkleBulletPointsIcon } from '@/icons';
import { Button, type ButtonProps } from '@/ui_v3';
export const AiAnswerGenerationButton = ({
  onClick,
  disabled,
  ...rest
}: Omit<ButtonProps, 'asChild'>) => {
  const {
    t
  } = useTranslation(['build']);
  return <Button {...rest} disabled={disabled} size="xs" variant="transparent" intent="neutral" leftSlot={<SparkleBulletPointsIcon size="xs" fill={disabled ? ICON_COLOR.disabled : ICON_COLOR.default} />} onClick={onClick} data-sentry-element="Button" data-sentry-component="AiAnswerGenerationButton" data-sentry-source-file="AiAnswerGenerationButton.tsx">
      {t('build:ai.generate.generationButton')}
    </Button>;
};